import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { LogModel } from 'src/app/models/log.model';


export class ConsultasLogsListModalFormDefinition {
  public readonly formFields: Form<LogModel>;
  public readonly model: Partial<LogModel>;

  constructor(type: FormType, model: Partial<LogModel>, _context: unknown = {}) {
    this.model = model;
    this.formFields = {
      name: 'consultas-logs-list-modal',
      header: 'Datos del log',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<LogModel>[] {
    return [
      {
        name: '',
        fields: [
          this.textField('fecha', 'Fecha', 1, true, 4),
          this.textField('hora', 'Hora', 2, true, 4),
          this.textField('usuario', 'Usuario', 3, true, 4),
          this.textField('ip_origen', 'IP Origen', 4, true, 4),
          this.textField('user_agent', 'Navegador', 5, true, 4),
        ],
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<LogModel> {
    return {
      name,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
